// extracted by mini-css-extract-plugin
export default {"container":"hthQu","button":"_7MHrt","icon":"_2iTvD","text":"_2bRKz","title":"_3y3wd","info":"KNFnf"};